import { PieChart, PieChartProps } from '../../renderers/pie-chart/pie-chart.component';
import { toWaitingDaysDonutChart } from '../../utils/to-waiting-days-donut-chart';

export const TransactionTimerWaitingDaysDonutChart = ({ chartOptions, ...props }: PieChartProps) => (
    <PieChart
        {...props}
        data={toWaitingDaysDonutChart(props.data)}
        variant='donut'
        chartOptions={{
            ...chartOptions,
            legend: {
                show: true,
                position: 'right',
                labels: {
                    colors: 'var(--color-foreground-default)'
                },
                ...chartOptions?.legend
            }
        }}
    />
);
